import { useNavigate } from "react-router-dom";

export default function Header({ role, username, theme, onToggleTheme, onLogout }) {
  const isAdmin = role === "Admin";
  const navigate = useNavigate();

  return (
    <header style={{
      borderBottom: "1px solid var(--header-border)", background: "var(--header-bg)",
      backdropFilter: "blur(12px)", position: "sticky", top: 0, zIndex: 50,
      padding: ".6rem 1.5rem", display: "flex", justifyContent: "space-between",
      alignItems: "center", boxShadow: "0 1px 20px rgba(0,0,0,.4)"
    }}>

      {/* Brand — logo + text */}
      <button onClick={() => navigate('/dashboard')} style={{
        background: "none", border: "none", cursor: "pointer",
        display: "flex", alignItems: "center", gap: ".75rem", padding: 0
      }}>
        {/* Logo with white background */}
        <div style={{
          width: 42, height: 42, background: "#ffffff",
          borderRadius: ".6rem", display: "flex", alignItems: "center",
          justifyContent: "center", overflow: "hidden", padding: 3,
          boxShadow: "0 2px 10px rgba(204,0,0,.2)", flexShrink: 0
        }}>
          <img
            src="/logo.svg"
            alt="IHRD"
            style={{ width: "100%", height: "100%", objectFit: "contain" }}
            onError={e => {
              e.target.style.display = "none";
              e.target.parentNode.innerHTML =
                '<span style="font-family:Orbitron,sans-serif;font-weight:700;font-size:.75rem;color:#cc0000">IHRD</span>';
            }}
          />
        </div>
        <div style={{ textAlign: "left" }}>
          <div className="techno grad-cyan" style={{ fontSize: ".8rem", fontWeight: 900, marginBottom: ".15rem" }}>
            IHRD — PMD
          </div>
          <div style={{ fontSize: ".58rem", color: "#64748b", textTransform: "uppercase", letterSpacing: ".12em" }}>
            Agreemented Revenue Management System
          </div>
        </div>
      </button>

      {/* Right side controls */}
      <div style={{ display: "flex", alignItems: "center", gap: "1rem" }}>

        {/* Role badge */}
        <div style={{
          display: "flex", alignItems: "center", gap: ".5rem",
          background: "#020617", border: "1px solid #1e293b",
          borderRadius: ".6rem", padding: ".35rem .75rem", fontSize: ".72rem"
        }}>
          <svg width="12" height="12" fill="none" stroke={isAdmin ? "#22d3ee" : "#2dd4bf"}
            strokeWidth="2" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round"
              d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"/>
          </svg>
          <span style={{ color: isAdmin ? "#22d3ee" : "#2dd4bf", fontWeight: 700 }}>{role}</span>
        </div>

        {/* Username */}
        <div style={{
          display: "flex", alignItems: "center", gap: ".4rem",
          fontSize: ".75rem", color: "#94a3b8"
        }}>
          <div style={{
            width: 28, height: 28, borderRadius: "50%",
            background: "linear-gradient(135deg,#06b6d4,#3b82f6)",
            display: "flex", alignItems: "center", justifyContent: "center",
            fontSize: ".7rem", fontWeight: 700, color: "#fff", flexShrink: 0
          }}>
            {username ? username[0].toUpperCase() : "U"}
          </div>
          <span style={{ fontWeight: 600, color: "#cbd5e1" }}>{username}</span>
        </div>

        <button onClick={onToggleTheme} style={{
          display: "flex", alignItems: "center", gap: ".4rem",
          background: "rgba(148,163,184,.12)", border: "1px solid rgba(148,163,184,.18)",
          borderRadius: ".6rem", padding: ".35rem .75rem", color: "#cbd5e1",
          fontSize: ".75rem", fontWeight: 600, cursor: "pointer", transition: "all .15s",
          fontFamily: "'Plus Jakarta Sans', sans-serif"
        }}
        onMouseEnter={e => e.currentTarget.style.background = "rgba(148,163,184,.18)"}
        onMouseLeave={e => e.currentTarget.style.background = "rgba(148,163,184,.12)"}>
          <span>{theme === "dark" ? "☀️ Light" : "🌙 Dark"}</span>
        </button>

        {/* System status */}
        <div style={{ textAlign: "right", display: "none", flexDirection: "column" }}
          className="md-show">
          <div style={{ fontSize: ".58rem", color: "#64748b", fontWeight: 700,
            textTransform: "uppercase", letterSpacing: ".1em" }}>Engine</div>
          <div style={{ fontSize: ".65rem", color: "#34d399", fontWeight: 600,
            display: "flex", alignItems: "center", gap: ".3rem" }}>
            <span style={{ width: 7, height: 7, borderRadius: "50%", background: "#10b981",
              display: "inline-block", animation: "ping 1.5s infinite" }}></span>
            LIVE
          </div>
        </div>

        {/* Logout button */}
        <button onClick={onLogout} style={{
          display: "flex", alignItems: "center", gap: ".35rem",
          background: "rgba(239,68,68,.1)", border: "1px solid rgba(239,68,68,.25)",
          borderRadius: ".6rem", padding: ".35rem .75rem",
          color: "#f87171", fontSize: ".75rem", fontWeight: 600,
          cursor: "pointer", transition: "all .15s",
          fontFamily: "'Plus Jakarta Sans', sans-serif"
        }}
        onMouseEnter={e => e.currentTarget.style.background = "rgba(239,68,68,.2)"}
        onMouseLeave={e => e.currentTarget.style.background = "rgba(239,68,68,.1)"}>
          <svg width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round"
              d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"/>
          </svg>
          Logout
        </button>
      </div>
    </header>
  );
}
